import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function UserCircleFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.6983 2.32833C16.6983 2.32833 16.6983 2.32833 16.6983 2.32833V2.32833ZM21.6717 7.30171C21.6717 7.30172 21.6717 7.3017 21.6717 7.30171V7.30171Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 11.1576 22.6531 10.3379 22.4699 9.55136C22.2867 8.76481 22.0171 8.0114 21.6717 7.30171C21.4877 6.9237 21.2822 6.55811 21.0568 6.20649C20.2177 4.89744 19.1026 3.78229 17.7935 2.94317C17.4419 2.71778 17.0763 2.5123 16.6983 2.32833C16.2187 2.09492 15.7191 1.89613 15.2029 1.73521C14.3822 1.47942 13.5194 1.31933 12.6274 1.268C12.4198 1.25606 12.2106 1.25 12 1.25ZM6.0604 17.5193C6.95061 15.9614 8.60733 15 10.4016 15H13.5984C15.3927 15 17.0494 15.9614 17.9396 17.5193L18.2955 18.1422C16.6982 19.7791 14.4678 20.7955 12 20.7955C9.5322 20.7955 7.30178 19.7791 5.70447 18.1422L6.0604 17.5193ZM15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z"
				fill="currentColor"
			/>
		</svg>
	);
}

UserCircleFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default UserCircleFilledIcon;
